import type { ReactNode, CSSProperties } from 'react';
import { BottomTabBar } from '../navigation/BottomTabBar';

interface AppLayoutProps {
  children: ReactNode;
}

const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden', // Prevent body scroll, let content areas handle their own scrolling
  } satisfies CSSProperties,
  main: {
    flex: 1,
    minHeight: 0, // Allow flex child to shrink and report height correctly to children
    height: 0, // Explicit height allows children with height: 100% to work
    paddingBottom: 56, // Height of BottomTabBar
  } satisfies CSSProperties,
};

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div style={styles.container}>
      <main style={styles.main} role="main">
        {children}
      </main>
      <BottomTabBar />
    </div>
  );
}
